"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get genSqlite3AggregateQuery () {
        return genSqlite3AggregateQuery;
    },
    get replaceDelimitedWithKeyValueSqlite3 () {
        return replaceDelimitedWithKeyValueSqlite3;
    }
});
const _nocodbsdk = require("nocodb-sdk");
function genSqlite3AggregateQuery({ column, baseModelSqlv2, aggregation, column_query, parsedFormulaType, aggType, alias }) {
    let aggregationSql;
    const { dbDriver: knex } = baseModelSqlv2;
    let condnValue = "''";
    if ([
        _nocodbsdk.UITypes.CreatedTime,
        _nocodbsdk.UITypes.LastModifiedTime,
        _nocodbsdk.UITypes.Date,
        _nocodbsdk.UITypes.DateTime,
        _nocodbsdk.UITypes.Number,
        _nocodbsdk.UITypes.Decimal,
        _nocodbsdk.UITypes.Year,
        _nocodbsdk.UITypes.Currency,
        _nocodbsdk.UITypes.Duration,
        _nocodbsdk.UITypes.Time,
        _nocodbsdk.UITypes.Percent,
        _nocodbsdk.UITypes.Rollup,
        _nocodbsdk.UITypes.Links,
        _nocodbsdk.UITypes.ID
    ].includes(column.uidt) || [
        _nocodbsdk.FormulaDataTypes.DATE,
        _nocodbsdk.FormulaDataTypes.NUMERIC
    ].includes(parsedFormulaType)) {
        condnValue = 'NULL';
    } else if ([
        _nocodbsdk.UITypes.Rating
    ].includes(column.uidt)) {
        condnValue = 0;
    }
    if (aggType === 'common') {
        switch(aggregation){
            case _nocodbsdk.CommonAggregations.Count:
                aggregationSql = knex.raw(`COUNT(*)`);
                break;
            case _nocodbsdk.CommonAggregations.CountEmpty:
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`SUM(CASE WHEN json_array_length(??) IS NULL THEN 1 ELSE 0 END)`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`SUM(CASE WHEN (??) IS NULL OR (??) = ${condnValue} THEN 1 ELSE 0 END)`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.CountFilled:
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.JSON,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`SUM(CASE WHEN (??) IS NOT NULL THEN 1 ELSE 0 END)`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`SUM(CASE WHEN (??) IS NOT NULL AND (??) != ${condnValue} THEN 1 ELSE 0 END)`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.CountUnique:
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`COUNT(DISTINCT json_extract(??, '$'))`, [
                        column_query
                    ]);
                    break;
                }
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`COUNT(DISTINCT CASE WHEN (??) IS NOT NULL THEN (??) END)`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`COUNT(DISTINCT CASE WHEN (??) IS NOT NULL AND (??) != ${condnValue} THEN ?? END)`, [
                    column_query,
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.PercentEmpty:
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`(SUM(CASE WHEN json_array_length(??) IS NULL THEN 1 ELSE 0 END) * 100.0 / IFNULL(COUNT(*), 0))`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`(SUM(CASE WHEN (??) IS NULL OR (??) = ${condnValue} THEN 1 ELSE 0 END) * 100.0 / IFNULL(COUNT(*), 0))`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.PercentFilled:
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.JSON,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`(SUM(CASE WHEN (??) IS NOT NULL THEN 1 ELSE 0 END) * 100.0 / IFNULL(COUNT(*), 0))`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`(SUM(CASE WHEN (??) IS NOT NULL AND (??) != ${condnValue} THEN 1 ELSE 0 END) * 100.0 / IFNULL(COUNT(*), 0))`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.PercentUnique:
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`COUNT(DISTINCT json_extract((??), '$')) * 100.0 / IFNULL(COUNT(*), 0)`, [
                        column_query
                    ]);
                    break;
                }
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`(COUNT(DISTINCT CASE WHEN (??) IS NOT NULL THEN (??) END) * 100.0 / IFNULL(COUNT(*), 0))`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`(COUNT(DISTINCT CASE WHEN (??) IS NOT NULL AND (??) != ${condnValue} THEN (??) END) * 100.0 / IFNULL(COUNT(*), 0))`, [
                    column_query,
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.None:
                break;
        }
    } else if (aggType === 'numerical') {
        switch(aggregation){
            case _nocodbsdk.NumericalAggregations.Avg:
                if (column.uidt === _nocodbsdk.UITypes.Rating) {
                    aggregationSql = knex.raw(`AVG(CASE WHEN (??) != ${condnValue} THEN (??) ELSE NULL END)`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`AVG((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Max:
                aggregationSql = knex.raw(`MAX((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Min:
                if (column.uidt === _nocodbsdk.UITypes.Rating) {
                    aggregationSql = knex.raw(`MIN(CASE WHEN (??) != ${condnValue} THEN (??) ELSE NULL END)`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`MIN((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Sum:
                aggregationSql = knex.raw(`SUM((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.StandardDeviation:
                aggregationSql = knex.raw(`(
    SELECT 
      CASE 
        WHEN COUNT(*) > 0 THEN 
          SQRT(SUM(((??) - avg_value) * ((??) - avg_value)) / COUNT(*))
        ELSE 
          NULL 
      END AS ??
    FROM (
      SELECT 
        (??), 
        (SELECT AVG((??)) FROM ??) AS avg_value
      FROM 
        ??
    )
  )`, [
                    column_query,
                    column_query,
                    alias,
                    column_query,
                    column_query,
                    baseModelSqlv2.tnPath,
                    baseModelSqlv2.tnPath
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Range:
                if (column.uidt === _nocodbsdk.UITypes.Rating) {
                    aggregationSql = knex.raw(`(MAX((??)) - MIN(CASE WHEN (??) != ${condnValue} THEN (??) ELSE NULL END))`, [
                        column_query,
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`(MAX((??)) - MIN((??)))`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Median:
                aggregationSql = knex.raw(`(SELECT AVG((??)) FROM (SELECT (??) FROM ?? ORDER BY (??) LIMIT 2 - (SELECT COUNT(*) FROM ??) % 2 OFFSET (SELECT (COUNT(*) - 1) / 2 FROM ??)))`, [
                    column_query,
                    column_query,
                    baseModelSqlv2.tnPath,
                    column_query,
                    baseModelSqlv2.tnPath,
                    baseModelSqlv2.tnPath
                ]);
                break;
            default:
                break;
        }
    } else if (aggType === 'boolean') {
        switch(aggregation){
            case _nocodbsdk.BooleanAggregations.Checked:
                aggregationSql = knex.raw(`SUM(CASE WHEN ?? = 1 THEN 1 ELSE 0 END)`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.BooleanAggregations.Unchecked:
                aggregationSql = knex.raw(`SUM(CASE WHEN ?? = 0 OR ?? IS NULL THEN 1 ELSE 0 END)`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.BooleanAggregations.PercentChecked:
                aggregationSql = knex.raw(`(SUM(CASE WHEN ?? = 1 THEN 1 ELSE 0 END) * 100.0 / IFNULL(COUNT(*), 0))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.BooleanAggregations.PercentUnchecked:
                aggregationSql = knex.raw(`(SUM(CASE WHEN ?? = 0 OR ?? IS NULL THEN 1 ELSE 0 END) * 100.0 / IFNULL(COUNT(*), 0))`, [
                    column_query,
                    column_query
                ]);
                break;
            default:
                break;
        }
    } else if (aggType === 'date') {
        switch(aggregation){
            case _nocodbsdk.DateAggregations.EarliestDate:
                aggregationSql = knex.raw(`MIN(??)`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.DateAggregations.LatestDate:
                aggregationSql = knex.raw(`MAX(??)`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.DateAggregations.DateRange:
                aggregationSql = knex.raw(`CAST(JULIANDAY(MAX(??)) - JULIANDAY(MIN(??)) AS INTEGER)`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.DateAggregations.MonthRange:
                aggregationSql = knex.raw(`((strftime('%Y', MAX(??)) * 12 + strftime('%m', MAX(??))) - (strftime('%Y', MIN(??)) * 12 + strftime('%m', MIN(??))))`, [
                    column_query,
                    column_query,
                    column_query,
                    column_query
                ]);
                break;
            default:
                break;
        }
    } else if (aggType === 'attachment') {
        switch(aggregation){
            case _nocodbsdk.AttachmentAggregations.AttachmentSize:
                aggregationSql = knex.raw(`(SELECT SUM(CAST(json_extract(value, '$.size') AS INTEGER)) FROM ??, json_each(??))`, [
                    baseModelSqlv2.tnPath,
                    column_query
                ]);
                break;
            default:
                break;
        }
    }
    if (aggregationSql) {
        if (![
            _nocodbsdk.AllAggregations.EarliestDate,
            _nocodbsdk.AllAggregations.LatestDate
        ].includes(aggregation)) {
            aggregationSql = knex.raw(`COALESCE(??, 0)`, [
                aggregationSql
            ]);
        }
        if (alias) {
            aggregationSql = knex.raw(`?? AS ??`, [
                aggregationSql,
                alias
            ]);
        }
    }
    return aggregationSql == null ? void 0 : aggregationSql.toQuery();
}
function replaceDelimitedWithKeyValueSqlite3(params) {
    var _params_delimiter;
    const delimiter = (_params_delimiter = params.delimiter) != null ? _params_delimiter : ',';
    const knex = params.knex;
    if (!params.stack || params.stack.length === 0) {
        return knex.raw(`??`, [
            params.needleColumn
        ]).toQuery();
    }
    // create union replace statement for each user
    const mapUnion = params.stack.map((row)=>{
        return knex.raw(`select ? as nc_p_key, ? as nc_p_value`, [
            row.key,
            row.value
        ]).toQuery();
    }).join(' UNION ALL ');
    const needleAsRows = knex.raw(`select ?? as nc_raw_needle, nc_t_stack_1.value as nc_p_needle from (json_each('["' || replace(??, '${delimiter}', ?) || '"]')) nc_t_stack_1`, [
        params.needleColumn,
        params.needleColumn,
        `"${delimiter}"`
    ]).toQuery();
    return knex.raw([
        `select nc_p_result from (`,
        `  select nc_t_needle.nc_raw_needle, GROUP_CONCAT(coalesce(nc_t_stack.nc_p_value, nc_t_stack.nc_p_key), '${delimiter}') as nc_p_result`,
        `  from (${needleAsRows}) nc_t_needle`,
        `  left join (${mapUnion}) nc_t_stack`,
        `    on nc_t_needle.nc_p_needle = nc_t_stack.nc_p_key`,
        `  group by nc_t_needle.nc_raw_needle`,
        `) nc_subquery`
    ].join(' ')).toQuery();
}
